import { log } from "@/utils/logger";
import { useQuery } from "@tanstack/react-query";
import api from "@/config/api";
import useUser from "@/context/user";
import { Organization } from "@/types/org";
import { Role } from "@/types/user";

const useQueryOrganizations = () => {
    const authenticated = useUser(state => state.authenticated);

    const getOrganizations = async () => {
        try {
            const data = await api.get<
                Record<string, { role: Role; organization: Omit<Organization, "id"> }>
            >("/organizations");
            return data;
        } catch (e) {
            log.error(e, "getOrganizations");
        }
    };

    return useQuery({
        queryKey: ["organizations"],
        queryFn: getOrganizations,
        enabled: authenticated,
    });
};

export default useQueryOrganizations;
